import { useCallback } from 'react';

import { ArrowsComponent } from '../../../shared/components/arrows/arrows';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import type { FCWithChildren } from '../../../shared/utils/component.interface';
import { TopNavigationView } from '../large-top-navigation/large-top-navigation.interface';

import styles from './field-section.module.scss';

const style = createStyleHelper(styles, 'field-section');

export interface IFieldSectionProps {
    className?: string;
    usedView: TopNavigationView;
    currentView: TopNavigationView;
    toggleCurrentView: (view: TopNavigationView) => void;
}

export const FieldSectionComponent: FCWithChildren<IFieldSectionProps> = ({
    className,
    usedView,
    currentView,
    toggleCurrentView,
    children,
    ...restProps
}) => {
    const onClick = useCallback(() => {
        toggleCurrentView(usedView);
    }, [usedView, toggleCurrentView]);

    return (
        <div
            className={createClassName([
                className,
                style(undefined, {
                    active: currentView === usedView,
                    balance: usedView === TopNavigationView.BALANCE,
                }),
            ])}
            onClick={onClick}
            {...restProps}
        >
            <div
                className={style('details', {
                    balance: usedView === TopNavigationView.BALANCE,
                    profile: usedView === TopNavigationView.PROFILE,
                })}
            >
                {children}
            </div>
            <ArrowsComponent status={currentView === usedView} />
        </div>
    );
};
